import axios from 'axios'
import {
  matchModuleByApiUrl,
  matchModuleByRoutePath,
} from '../config/appModules'
import { canEditModule } from '../utils/moduleAccess'

const instance = axios.create({
  baseURL: process.env.REACT_APP_MAIN_API_ROOT,
  withCredentials: true,
})

const mutationMethods = new Set(['post', 'put', 'patch', 'delete'])

const isPublicWeddingParticipantSubmission = (
  method: string,
  url: string,
): boolean => {
  return method === 'post' && url.startsWith('/wedding/participants')
}

const getCurrentAppPath = (): string => {
  const hashPath = window.location.hash.slice(1)
  return hashPath || window.location.pathname || '/'
}

const getAuthUser = () => {
  return (
    window as Window & {
      __IVA_STORE__?: { getState: () => { auth?: { user?: any } } }
    }
  ).__IVA_STORE__?.getState().auth?.user
}

const getCurrentRouteModule = (): string | undefined => {
  return matchModuleByRoutePath(getCurrentAppPath())
}

const getRequestModule = (url: string): string | undefined => {
  if (
    url.startsWith('/users/login') ||
    url.startsWith('/users/logout') ||
    url.startsWith('/users/private-mode')
  ) {
    return undefined
  }

  if (url.startsWith('/files') && !url.startsWith('/files/folders')) {
    return getCurrentRouteModule() || 'files'
  }

  return matchModuleByApiUrl(url) || getCurrentRouteModule()
}

instance.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase()

  if (!method || !mutationMethods.has(method)) {
    return config
  }

  const requestUrl = config.url || ''

  if (isPublicWeddingParticipantSubmission(method, requestUrl)) {
    return config
  }

  if (requestUrl.startsWith('/reminders')) {
    return config
  }

  const moduleCode = getRequestModule(requestUrl)

  if (!moduleCode) {
    return config
  }

  const user = getAuthUser()

  if (canEditModule(user, moduleCode)) {
    return config
  }

  return Promise.reject(
    new Error('You do not have permission to edit this module.'),
  )
})

export default instance
